import { PropsWithChildren, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { SessionStorageKeys } from 'constants/constants'
import { updateMarketingStore } from 'store/marketing/slice'
import { getSessionStorageItem, removeSessionStorageItem } from 'utils/sessionStorage'

const StoreInitializer = ({ children }: PropsWithChildren) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const serializedStore = getSessionStorageItem(SessionStorageKeys.MARKETING)

    if (serializedStore) {
      try {
        dispatch(updateMarketingStore({ marketingStore: JSON.parse(serializedStore) }))
      } catch (_) {
        removeSessionStorageItem(SessionStorageKeys.MARKETING)
      }
    }
  }, [dispatch])

  return children
}

export default StoreInitializer
